import { useDmNotificationPatient } from '../../../../hooks/useDmNotifications';
import type { DmResolvedNotification } from '../../../../services/dmNotifications';
import {
    patientViewStatus,
    useLastKnownNeighbours,
    useListPositionLabel
} from '../../shared/patientViewState';
import type { NotificationListParams } from '../notificationListParams';
import { useNotificationApiFilters } from '../useNotificationApiFilters';

const NO_RESOLVED: DmResolvedNotification[] = [];

// Mount one per patient (keyed by id): the remembered neighbours and position are that patient's alone.
export function useNotificationPatientView(patientId: string, listParams: NotificationListParams) {
    const { apiFilters, assigneesResolved } = useNotificationApiFilters(listParams);
    const query = useDmNotificationPatient(patientId, apiFilters, { enabled: assigneesResolved });
    const neighbours = useLastKnownNeighbours(query.data);
    const listPosition = query.data?.listPosition;
    const positionLabel = useListPositionLabel(listPosition);

    const status = patientViewStatus(query.data !== undefined, query.isError, query.error);

    return {
        status,
        patient: query.data?.patient ?? null,
        recentlyResolved: query.data?.recentlyResolved ?? NO_RESOLVED,
        ...neighbours,
        positionLabel,
        listTotal: listPosition?.total ?? null,
        retry: () => void query.refetch()
    };
}
